const IEMapService = require('./IEMapService');


/**
 * @description 资源目录统计结果
 * @typedef G.service.IResourceCatalogService~StatisticsResult
 * @type Object
 * @property {Object} statistics 统计结果集
 * @property {Object} [statistics[nodeId]] 每个节点统计信息，nodeId为每个节点id
 * @property {String} [statistics[nodeId].type] 节点类型;node=分类节点;table=资源表;
 * @property {Number} [statistics[nodeId].dataCount] 数据记录数
 * @property {Number} [statistics[nodeId].resourceCount] 资源节点数
 * @property {String} [statistics[nodeId].parentId] 父节点 ID
 */

/**
 * @classdesc 资源目录服务接口
 * @alias G.service.IResourceCatalogService
 * @augments G.service.IEMapService
 * @param opts
 * @param opts.httpRequest {G.base.IHttpRequest} 请求对象
 * @param opts.url {String} 服务地址
 */
class IResourceCatalogService extends IEMapService {
    constructor(opts) {
        super(opts);
    }

    /**
     * 资源目录统计
     * @param {Object} opts  
     * @param {String} opts.treeId  树ID
     * @param {String} [opts.nodeId] 节点ID，统计节点及其子节点；默认为树根节点
     * @returns {G.service.IResourceCatalogService~StatisticsResult}
     */
    stat(opts) {}

}
module.exports = IResourceCatalogService;